import moment from 'moment'
import { EventItem } from '../../../domain/EventItem'
import { FULFILLED } from '../action-helper'
import { FETCH_EVENTS } from './actions'
import { eventKey } from './common'
import { EventState } from './EventState'

const initialState: EventState = {
    byKey: {},
    loaded: false,
}

export const eventStateReducer = (state: EventState = initialState, action: any): EventState => {
    switch (action.type) {
        case FULFILLED(FETCH_EVENTS):
            return {
                ...state,
                byKey: {
                    ...state.byKey,
                    ...fetchDailyReports(action),
                },
                loaded: true,
            }
        default:
            return state
    }
}

const fetchDailyReports = (action: any) => {
    const byKey = {}
    const { environment, service, data } = action.payload

    data.map((event: EventItem) => {
        const day = moment(event.eventDate).format('YYYY-MM-DD')
        const key = eventKey(environment, service, day)

        byKey[key] = byKey[key] ? [...byKey[key], event] : [event]
    })

    return byKey
}
